import React from "react";
import BrandFeatureCard from "../cards/BrandFeatureCard";
import AI from "../../assets/ai-powered.png";
import VR from "../../assets/vr-icon.png";
import ROBO from "../../assets/diy-robot.png";
import Screen1 from "../../assets/screen1.png";
import Screen2 from "../../assets/screen2.png";
import Screen3 from "../../assets/screen3.png";

const FeatureCards = () => {
  return (
    <div className="bg-[#F5F5F5]">
      <div className="px-4 pb-12 pt-10 sm:px-6 sm:pb-16 sm:pt-12 xl:px-8 xl:pb-24 xl:pt-[66px]">
        <div className="mx-auto grid max-w-[1752px] grid-cols-1 gap-4 min-[600px]:grid-cols-2 lg:grid-cols-3 xl:gap-x-6">
          <BrandFeatureCard
            title="AI-Powered 3D Immersive Learning"
            headingIcon={AI}
            cardImage={Screen2}
            subText="Our platform features real-time performance tracking, adaptive learning paths, and AI assistants that deliver intelligent teaching and personalized recommendations for every student."
            pClassName="text-justify mt-4 sm:mt-5 min-h-0 sm:min-h-[115px]"
            btnpadding="pt-4 pb-6 sm:pt-5 sm:pb-8"
          />
          <BrandFeatureCard
            title="Immersive VR-Enabled 3D Learning"
            headingIcon={VR}
            cardImage={Screen1}
            subText="Our platform uses SLO-based modeling and simulations to let students explore science interactively — engaging deeply with concepts, conducting experiments, and understanding complex ideas with ease."
            pClassName="text-justify mt-4 sm:mt-5 min-h-0 sm:min-h-[115px]"
            btnpadding="pt-4 pb-6 sm:pt-5 sm:pb-8"
          />
          <BrandFeatureCard
            title="DIY Robo-Kits & Skill-Based Courses"
            headingIcon={ROBO}
            cardImage={Screen3}
            subText="We offer DIY Robotics Kits and custom skill-based courses that combine simulation with hands-on experimentation, helping students build problem-solving and analytical skills."
            pClassName="text-justify mt-4 sm:mt-5 min-h-0 sm:min-h-[115px]"
            btnpadding="pt-4 pb-6 sm:pt-5 sm:pb-8"
          />
        </div>
      </div>
    </div>
  );
};

export default FeatureCards;
